import { IAuth } from "../interfaces/IAuth";

export const AuthStateDefault: IAuth = {
    isLoggedIn: false,
    token: "",
};